import { Component, OnDestroy, OnInit } from '@angular/core';
import { SessionTimeoutService } from './core/services/session-timeout.service';
import { AppVersionService } from './core/services/app-version.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Avery Cloud';

  constructor(private sessionTimeoutService: SessionTimeoutService, public appVersion: AppVersionService) { }

  ngOnInit(): void {
    this.sessionTimeoutService.start();
    // #45: tell a tab opened before a release to reload — an old screen is refused on every money action afterwards
    this.appVersion.start();
  }

  ngOnDestroy(): void {
    this.sessionTimeoutService.stop();
    this.appVersion.stop();
  }
}
